module.exports = __webpack_public_path__ + "img/logo.719fedd0.svg";